<div class="padded-side-nav page-container">
    @if(displayTable)
    {<tools-table ApiPath="/teltonika/tags/" [Headers]="headers" #table [Search]="true" [HTTPPost]="false"
        [Actions]="actions" [Slim]="true" [DisplayCount]="displayCount" (Selected)="addSelected($event)" [Add]="true"
        (AddChange)="createTag()" [PageSizeOptions]="[10,25,50]" [IncludeAllPageSize]="true"></tools-table>
    }
    @else {
    <mat-spinner [diameter]="40"></mat-spinner>
    }
</div>